package com.bulut.mecitogullari.core.firebase

import dev.gitlive.firebase.FirebaseOptions

actual fun platformFirebaseOptions(): FirebaseOptions = FirebaseOptions(
    applicationId = FirebaseConfig.WEB_APP_ID,
    apiKey = FirebaseConfig.API_KEY_WEB,
    projectId = FirebaseConfig.PROJECT_ID,
    storageBucket = FirebaseConfig.STORAGE_BUCKET,
    gcmSenderId = FirebaseConfig.MESSAGING_SENDER_ID,
    authDomain = FirebaseConfig.AUTH_DOMAIN,
)
